import { useAppSelector } from '@app/core/hooks/redux-hooks';

const useGetHistoricDividendYears = () => {
  const project = useAppSelector((state) => state.project.projectDraft);
  const yearEndDate = project.yearEndDate;
  const investmentDate = project.investmentDate;
  const valuationDate = project.valuationDate;

  const [yearEndMonth, yearEndDay] = yearEndDate.split('-').slice(1);
  const startYear = Number(investmentDate.split('-')[0]);
  const endYear = Number(valuationDate.split('-')[0]);

  const years: string[] = [];
  for (let year = startYear; year <= endYear; year++) {
    const yearEnd = `${year}-${yearEndMonth}-${yearEndDay}`;
    const yearEndDateObj = new Date(yearEnd);
    const investmentDateObj = new Date(investmentDate);
    const valuationDateObj = new Date(valuationDate);
    if (yearEndDateObj >= investmentDateObj && yearEndDateObj <= valuationDateObj) {
      years.push(yearEnd);
    }
  }
  return years;
};

export default useGetHistoricDividendYears;
